export const TEST_ID = 'servicePhotoThumb';

export const REMOVE_TEST_ID = 'servicePhotoThumbRemove';
